// src/components/tokenPage/overview/MarketRelationshipsCard.tsx

import React, { useState } from "react";
import TimeRangePicker from "@/components/common/TimeRangePicker";
import { MetricBox } from "../shared/TokenDashboardComponents";
import { DataCard } from "@/components/ui";
import { useBenchmarkMetrics } from "@/hooks/metrics";

type TimeWindow = '30d' | '90d' | '180d' | '365d';

const WINDOW_DAYS: Record<TimeWindow, number> = {
  '30d': 30,
  '90d': 90,
  '180d': 180,
  '365d': 365,
};

const MarketRelationshipsCard: React.FC = () => {
  const [corrWindow, setCorrWindow] = useState<TimeWindow>('90d');
  
  const windowDays = WINDOW_DAYS[corrWindow];
  const btcMetrics = useBenchmarkMetrics('BTC', windowDays);
  const ethMetrics = useBenchmarkMetrics('ETH', windowDays);

  const isLoading = btcMetrics.isLoading || ethMetrics.isLoading;

  // Hide if no data available (after loading)
  const hasData = btcMetrics.beta != null || ethMetrics.beta != null || 
                  btcMetrics.correlation != null || ethMetrics.correlation != null;
  if (!isLoading && !hasData) {
    return null;
  }

  return (
    <DataCard
      title="Market Relationships"
      subtitle="Beta and correlation with BTC/ETH"
      icon="git-compare"
      iconColor="text-cyan-400"
      isLoading={isLoading}
      loadingVariant="stats"
      actions={
        <TimeRangePicker 
          options={['30d', '90d', '180d', '365d'] as const} 
          value={corrWindow} 
          onChange={setCorrWindow} 
          theme="blue" 
        />
      }
    >
      <div className="grid grid-cols-2 gap-2">
        <MetricBox label="Beta vs BTC" value={btcMetrics.beta} fmt="ratio2" toneBySign />
        <MetricBox label="Beta vs ETH" value={ethMetrics.beta} fmt="ratio2" toneBySign />
        <MetricBox label="Corr vs BTC" value={btcMetrics.correlation} fmt="ratio2" />
        <MetricBox label="Corr vs ETH" value={ethMetrics.correlation} fmt="ratio2" />
      </div>
    </DataCard>
  );
};

export default MarketRelationshipsCard;
